import type {ChronologicalCommentsSort} from '@github-ui/commenting/useCommentsSortPreference'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import {TEST_IDS} from '../../constants/test-ids'
import cardAlignmentStyles from './card-alignment.module.css'
import styles from './CommentsHeader.module.css'
import {CommentsSortMenu} from './CommentsSortMenu'

type CommentsHeaderProps = {
  headingId: string
  sort?: ChronologicalCommentsSort
  onSortChange: (sort: ChronologicalCommentsSort) => void
  trailingControl?: ReactNode
}

export function CommentsHeader({headingId, sort, onSortChange, trailingControl}: CommentsHeaderProps) {
  return (
    <div
      data-testid={TEST_IDS.commentsHeader}
      className={clsx(
        styles.container,
        !isFeatureEnabled('issue_inline_avatars') && cardAlignmentStyles.alignWithCards,
      )}
    >
      <h2 id={headingId} className={styles.heading}>
        Comments
      </h2>
      <div className={styles.controls}>
        {sort && <CommentsSortMenu sort={sort} onSortChange={onSortChange} />}
        {trailingControl}
      </div>
    </div>
  )
}
